import { BasePlugin } from "./base";

const DARK_CANVAS = '#1f2933';
const LIGHT_CANVAS = '#ffffff';

// Flips the editor canvas so text matching the section background stays visible while editing.
export class ContrastBackgroundPlugin extends BasePlugin {
  constructor(protected tinymce) {
    super(tinymce);
  }

  // Perceived brightness, 0 (black) to 1 (white).
  private brightness(color: string): number {
    let value = 1;
    const parts = /rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)/i.exec(color);
    if (parts) {
      const r = parseInt(parts[1], 10);
      const g = parseInt(parts[2], 10);
      const b = parseInt(parts[3], 10);
      value = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    }
    return value;
  }

  private contrastCanvas(body: any): string {
    let canvas = DARK_CANVAS;
    const current = body.ownerDocument.defaultView.getComputedStyle(body).backgroundColor;
    if (this.brightness(current) < 0.5) {
      canvas = LIGHT_CANVAS;
    }
    return canvas;
  }

  public create() {
    this.tinymce.PluginManager.add("contrast-background", (editor) => {
      let active = false;
      let original = '';

      editor.ui.registry.addToggleButton('contrast-background', {
        icon: 'contrast',
        tooltip: 'Flip the background — shows text that matches the section background',
        onAction: (api) => {
          const body = editor.getBody();
          if (body) {
            active = !active;
            if (active) {
              original = body.style.cssText;
              body.style.background = this.contrastCanvas(body);
            } else {
              body.style.cssText = original;
            }
            api.setActive(active);
          }
        }
      });
    });
  }
}
